var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"tms-title"},[_vm._v(_vm._s(_vm.title))]),_c('WorkOrderForm',{staticClass:"mt-md-4",attrs:{"woType":_vm.woType}}),_c('work-order-list',{attrs:{"woType":_vm.woType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }